<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.recordHistory}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="product.title | safeHtml"></span>
	</h5>
</div>
<div class="modal-body">
    <div *ngIf="lockObj && lockObj.lockType && lockObj.lockedBy !== username">
        <em>{{LOCALIZATION.lockedBy}}: {{lockObj.lockedBy}}</em>
    </div>
    <div *ngIf="lockObj == null || !lockObj.lockType || ( lockObj.lockedBy === username && lockObj.lockType == 'CHECKOUT') ">
        <!-- if permitted, show checkout option. If already checked out, show download, undo checkout and check in -->
        <div *ngIf="userPermissions['ROLE_PRODUCT_UPDATE'] && !lockObj || !lockObj.lockType"
        	 class="revision-tools">
        	 <div class="row">
        	 	<span *ngIf="lockObj.hasExternalSource" class="col-xs-4 help-block alert-warning">
        	 		Products that have been indexed in place are not supported for Check Out.
        	 	</span>
        	 </div>
        	 <a (click)="checkOut()" class="accent-color pointMe" [ngClass]="{disabled: lockObj.hasExternalSource}">{{LOCALIZATION.checkOutDocument}}</a>
        </div>
        <div *ngIf="userPermissions['ROLE_PRODUCT_UPDATE'] && ( lockObj.lockedBy === username && lockObj.lockType == 'CHECKOUT')">
            <input id="file-upload" type="file" fileinput (filesSelected)="onFilesSelected($event)" aria-label="File upload input"/>
            <div class="revision-tools">
                <a type="button" class="btn btn-default btn-xs" (click)="download()" href="{{downloadLink}}">
                    <i class="fas fa-spinner fa-spin fa-fw" *ngIf="inprogress"></i>
                	{{LOCALIZATION.download}}
                </a>
	            <a class="pointMe" (click)="checkIn()">{{LOCALIZATION.checkInDocument}}</a>
	            <a class="pointMe" (click)="undoCheckOut()">{{LOCALIZATION.checkOutDocumentUndo}}</a>
            </div>
        </div>

        <div *ngIf="revisions && revisions.length > 0" style="max-height:400px;overflow-y:auto;overflow-x:hidden">
            <div class="col-xs-4">
                <div *ngFor='let revision of revisions; let i = index;' 
                	(click)="selectRevision(i)" 
                	class="item-hover pointMe" 
                	[ngClass]="{'item-selected' : i == currentIndex, 'item-targeted': revision.versionNumber == revertTarget}" 
                	style="padding:5px">
	                    <span>{{LOCALIZATION.recordHistoryVersion}} {{revision.versionNumber}}</span>
	                    <i *ngIf="userPermissions['ROLE_PRODUCT_REVERT'] && revision.versionNumber != 0" 
	                    	title="{{LOCALIZATION.recordHistoryRestoreMessage}}" 
	                    	class="btn-xs fa fa-history pull-right accent-color" 
	                        (mouseover)="selectRevertTarget(revision.versionNumber-1)"
	                        (mouseleave)="selectRevertTarget(revision.versionNumber-1)"
	                    	aria-hidden="true" (click)="revert()"></i>
                </div>
            </div>
            <div class="col-xs-8">
                <p title="{{currentRevision.createdStr}}"><b>{{LOCALIZATION.created}}:</b> {{currentRevision.createdStr}}</p>
                <p title="{{currentRevision.userName}}"><b>{{LOCALIZATION.user}}:</b> {{currentRevision.userName}}</p>
                <p title="{{currentRevision.versionType}}"><b>{{LOCALIZATION.type}}:</b> {{currentRevision.versionType}}</p>
                <p title="{{currentRevision.uri}}" [hidden]="!currentRevision.uri"><b>{{LOCALIZATION.URL}}:</b> {{currentRevision.uri}}</p>
                <p title="{{currentRevision.details}}" [hidden]="!currentRevision.details"><b>{{LOCALIZATION.details}}:</b> {{currentRevision.details}}</p>
                <p title="{{currentRevision.uri}}" [hidden]="currentRevision.versionNumber == 0"><b>{{LOCALIZATION.versionNotes}}:</b></p>
				<textarea [(ngModel)]="currentRevision.notes" id="revisionNotes" name="revisionNotes" 
					class="form-control" style="margin:0px; max-width:99%; resize:none; border:1px solid #9e9e9e;"
					rows="4" cols="71" placeholder="Enter any version notes." 
					maxlength="{{notes.limit}}"  
					wrap="hard"></textarea>                	
                    <span class="help-block pull-right">{{currentRevision?.notes?.length||0}}/{{notes.limit}}</span>
                </div>					
                
            </div>
        </div>
        <div *ngIf="!revisions || revisions.length == 0" >
            <em>{{LOCALIZATION.resultsEmpty}}</em>
        </div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
    <button class="btn btn-primary" *ngIf="revisions && revisions.length > 1" type="button" (click)="updateHistory()" [disabled]="inprogress">
    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
    	{{LOCALIZATION.updateNotes}}
    </button>
</div>
